export default {
  name: "WarningSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M30.21 25.64 17.86 4.22a2.15 2.15 0 0 0-3.71 0L1.79 25.64a2.14 2.14 0 0 0 1.86 3.21h24.7a2.14 2.14 0 0 0 1.86-3.21zM16 24.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.5-6.5a1.5 1.5 0 1 1-3 0v-6.5a1.5 1.5 0 1 1 3 0V18z",
  },
}
